import React from "react";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid2";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import DeleteIcon from "@mui/icons-material/Delete";
import { ITEMEDIT_LABELS } from "constants/modelConstants";
import { useStyles } from "./styles";
import ErrorToolTip from "pages/Common/ErrorToolTip";
import { IconButton } from "@mui/material";

const selectionTypes = {
    "T": "True",
    "F": "False",
    "TF": "Both",
    "R": "Required",
};

export const PreSelectedItem = ({ condition, errorData, type, index, handleEditComponent, isKBReadOnly, handleDelete, tabName, isSystemChoice }) => {
    const classes = useStyles();

    return (
        <div key={`item-${index}`}>
            <Grid container style={{ alignItems: 'center' }}>
                <Grid size={6}>
                    <TextField
                        value={condition}
                        onChange={(e) => handleEditComponent(e.target.value, 'condition', index)}
                        multiline
                        id="DefaultComponentCondition"
                        variant="filled"
                        margin="dense"
                        label={ITEMEDIT_LABELS[tabName]["DefaultComponentCondition"]}
                        // placeholder="DefaultComponentCondition"
                        slotProps={{
                            input: {
                            classes: { input: classes.textarea },
                            disableUnderline: true
                            }
                        }}
                        disabled={isSystemChoice || isKBReadOnly}
                    />
                </Grid>
                <Grid size={5}>
                    <FormControl>

                        <TextField
                            value={type}
                            onChange={e => handleEditComponent(e.target.value, 'type', index)}
                            id="DefaultComponentType"
                            select
                            variant="filled"
                            margin="dense"
                            label={ITEMEDIT_LABELS[tabName]["DefaultComponentType"]}
                            slotProps={{ input : { disableUnderline: true }}}
                            disabled={isSystemChoice}

                        >
                            {Object.keys(selectionTypes).map(key => (
                                <MenuItem key={key} value={key} disabled={isKBReadOnly}>
                                    {selectionTypes[key]}
                                </MenuItem>
                            ))}
                        </TextField>
                    </FormControl>
                </Grid>
                {(condition && type) && <IconButton disabled={isKBReadOnly} onClick={() => handleDelete(index)}><DeleteIcon className={ isKBReadOnly ? 'delete-icon-button-disabled' : classes.deleteIconButton}  style={{ cursor: 'pointer' }} /></IconButton>}
            </Grid>
            
            {errorData && 
                <ErrorToolTip data={errorData} />
            }
        </div>
    );
};
